import * as React from "react";

const Speed: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none">
            <path
                d="M7.99994 1L1.4035 10.235C1.11154 10.6438 0.965558 10.8481 0.971876 11.0185C0.977377 11.1669 1.04852 11.3051 1.16604 11.3958C1.30102 11.5 1.55218 11.5 2.05449 11.5H6.99994L5.99994 19L12.5964 9.76499C12.8883 9.35624 13.0343 9.15187 13.028 8.98147C13.0225 8.83312 12.9514 8.69489 12.8338 8.60418C12.6989 8.5 12.4477 8.5 11.9454 8.5H6.99994L7.99994 1Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default React.memo(Speed);
